export default "__VITE_ASSET__DONqNbf___"